const getStringWithDecimals = (value, decimalPlaces) => {
  // If decimal places aren't specified, return value as is
  if (decimalPlaces === undefined) return value.toString();
  return value.toFixed(decimalPlaces);
};

module.exports = (value, decimalPlaces) => {
  if (value === 0) return 0;
  if (value === null || value === undefined) return '';

  let result = '';

  // Convert string to number
  let tempValue = parseFloat(value);

  // Keep track of negative values
  const isNegative = tempValue < 0;
  if (isNegative) {
    tempValue = tempValue * -1;
  }

  // Convert to string with specified decimal places
  tempValue = getStringWithDecimals(tempValue, decimalPlaces);

  // remove leading zero
  if (/^0[1-9,]/g.test(tempValue)) {
    tempValue = tempValue.substring(1);
  }

  // add commas to float or integer
  if (tempValue.includes('.')) {
    const parts = tempValue.split('.');
    parts[0] = parts[0]
      .replace(/,/gi, '')
      .split(/(?=(?:\d{3})+$)/)
      .join(',');
    result = parts.join('.');
  } else {
    result = tempValue
      .replace(/,/gi, '')
      .split(/(?=(?:\d{3})+$)/)
      .join(',');
  }

  if (isNegative) {
    result = `-${result}`;
  }

  if (result === 'NaN') {
    return '';
  }

  return result;
};
